import publicIp from "public-ip";

const getClientIPv4 = async () => await publicIp.v4({
    fallbackUrls: [ "ipinfo.io" ]
})

export default getClientIPv4
